var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SubHeaderContainer',[_c('div',{staticClass:"kt-subheader__main"}),_c('div',{staticClass:"d-flex"})])
}
var staticRenderFns = []

export { render, staticRenderFns }